import * as firebase from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyA1bStJNvfbKWzXoMeT22VV9ohgen0CTfc",
    authDomain: "selfpause-10e5a.firebaseapp.com",
    databaseURL: "https://selfpause-10e5a.firebaseio.com",
    projectId: "selfpause-10e5a",
    storageBucket: "selfpause-10e5a.appspot.com",
    messagingSenderId: "1044371968440",
    appId: "1:1044371968440:web:5d372d9ae03978d32abf4d",
    measurementId: "G-6TV4FPS7L9"
};

let app;
app = firebase.initializeApp(firebaseConfig);
export { app }

export const initApp = () => {
    if (!app) {
        app = firebase.initializeApp(firebaseConfig);
        return app
    }
    else return app
}

export * from "./User"